<template>
  <div class="page">
    <div class="websafe">
      <YorkbbsImage class="websafe-logo" :src="require('@/assets/images/common/logo_image.png')"></YorkbbsImage>
      <div class="websafe-card">
        <div class="websafe-card__body">
          <div class="websafe-title">即将离开约克论坛</div>
          <div class="websafe-subtitle">您即将离开约克论坛，请注意您的账号和财产安全。</div>
          <div class="websafe-link">{{ url }}</div>
        </div>
        <div class="websafe-card__footer">
          <a class="websafe-button" rel="nofollow" :href="url">继续访问</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Websafe',
  data() {
    return {
      url: '',
    };
  },
  created() {
    this.url = this.$route?.query?.url || '';
  },
};
</script>
<style lang="scss" scoped>
.page {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.websafe-logo {
  width: 137px;
  margin-bottom: 10px;
  margin-left: 20px;
}

.websafe-card {
  box-sizing: border-box;
  width: 600px;
  background: #f7f7f7;
  border: 1px solid #bbbcbe;
  border-radius: 10px;
  padding: 30px;
}
.websafe-card__body {
  padding-bottom: 20px;
  border-bottom: 1px solid #bbbcbe;
}
.websafe-title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin-bottom: 10px;
}
.websafe-subtitle {
  font-size: 13px;
  line-height: 18px;
  margin-bottom: 12px;
}
.websafe-link {
  font-size: 13px;
  line-height: 18px;
}

.websafe-card__footer {
  text-align: right;
  padding-top: 30px;
}
.websafe-button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 90px;
  height: 34px;
  background: #0277d9;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
  &:hover {
    opacity: 0.8;
  }
}
</style>
